var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comTable"},[_c('Table',{staticStyle:{"margin-top":"30px"},attrs:{"border":"","columns":_vm.columns1,"loading":_vm.modal_loading,"data":_vm.dataTable,"show-summary":"","span-method":_vm.handleSpan,"summary-method":_vm.handleSummary}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d5ff971","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bipage/components/ComTable.vue
// module id = null
// module chunks = 